import { Component, OnInit, Input } from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-pre-login-header',
  templateUrl: './pre-login-header.component.html',
  styleUrls: ['./pre-login-header.component.css']
})
export class PreLoginHeaderComponent implements OnInit {

  @Input() headerTitle: string;
  @Input() headerSubText1: string;
  @Input() headerSubText2: string;
  cloudBasePath: string;

  constructor() { }

  ngOnInit() {
   //alert(this.headerTitle);
   this.cloudBasePath = environment.cloudBasePath;  }

}
